export class OlgaImageLoader {
  static BLURRED_IMG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89R8AApkBy17XrZoAAAAASUVORK5CYII=';

  static load({ src, width, quality }) {
    return `${src}?width=${width}&quality=${quality || 75}`;
  }
}
